import { internalError } from '../constants';
import type { Tracker } from '../types/tracker';

export const heapTracker: Tracker = {
  init: () => true,
  trackError: (error, details) => {
    if (!window.heap?.track) {
      return Promise.reject(internalError.init.heap);
    }
    return Promise.resolve(window.heap.track(error.name, details));
  },
  trackEvent: (eventName: string, details) => {
    if (!window.heap?.track) {
      return Promise.reject(internalError.init.heap);
    }
    return Promise.resolve(window.heap.track(eventName, details));
  }
};
